import { observer } from 'mobx-react-lite'
import { type OCRScopingJobSidePanelViewModel } from '@/features/jobs/scoping/OCRScopingJobSidePanelViewModel'
import { WorkspaceSelectorViewHeadingContainer } from '@/features/iam/workspaces/components/WorkspaceSelectorViewHeading/WorkspaceSelectorViewHeadingContainer'
import { Workspace } from '@/features/iam/workspaces/Workspace'
import {
  OCRScopingJobsListHeaderStatusColumns,
  OCRScopingJobsListHeaderWorkspaceFilter,
  OCRScopingJobsListHeaderItemColumns,
  OCRScopingJobsListHeader,
  OCRScopingJobsListHeaderSearch,
  OCRScopingJobsListHeaderStatusItem,
} from '@/features/jobs/scoping/components/OCRScopingJobsListHeader'

export interface OCRScopingJobsListHeaderContainerProps {
  vm: OCRScopingJobSidePanelViewModel
}

export const OCRScopingJobsListHeaderContainer = observer(
  function OCRScopingJobsListHeaderContainer({
    vm,
  }: OCRScopingJobsListHeaderContainerProps) {
    const bulkActionVm = vm.bulkActionVm
    return (
      <OCRScopingJobsListHeader>
        {vm.selectedStatusFilter ? (
          <>
            <OCRScopingJobsListHeaderSearch
              showSearchField={vm.showSearchField}
              statusFilterTitle={vm.selectedStatusFilter.title}
              statusFilterCount={vm.selectedStatusFilter.count}
              searchValue={vm.searchText.value}
              onSearchChange={vm.searchText.change}
              onBack={vm.clearStatusFilter}
              onToggleSearchField={vm.toggleSearchField}
            />
            <OCRScopingJobsListHeaderItemColumns
              showCheckbox={!!vm.selectedStatusFilter.bulkAction}
              checked={
                bulkActionVm.hasSomeItemsSelectedForBulkAction
                  ? 'indeterminate'
                  : bulkActionVm.hasAllItemsSelectedForBulkAction
              }
              onToggleSelectAll={bulkActionVm.toggleSelectAllItemForBulkAction}
              headerName={vm.selectedStatusFilter.headerName}
            />
          </>
        ) : (
          <>
            <OCRScopingJobsListHeaderWorkspaceFilter
              canManageOCRScopingJobs={vm.canManageOCRScopingJobs}
              workspaceSelector={
                <WorkspaceSelectorViewHeadingContainer
                  primaryText={null}
                  allOptionDropdownItem={<>All workspaces</>}
                  alwaysUseDropdown
                  workspaces={vm.workspaces}
                  dropdownTitle="Select workspace"
                  onChange={vm.selectWorkspaceForFiltering}
                  searcher={vm.workspaceSelectorVm}
                  renderName={(workspace) => <>{workspace.name}</>}
                  allOptionText={'All workspaces'}
                  value={
                    vm.workspaceFilter.type === 'AllWorkspaces'
                      ? Workspace.none
                      : vm.workspaceFilter.workspace
                  }
                  viewHeadingSize="small"
                  showClearButton
                />
              }
            />
            <OCRScopingJobsListHeaderStatusColumns />
            {vm.statusFilterOptions.map((statusFilter) => (
              <OCRScopingJobsListHeaderStatusItem
                key={statusFilter.id}
                isDisabled={statusFilter.count === 0}
                onPress={() => vm.setStatusFilter(statusFilter.id)}
                count={statusFilter.count}
                title={statusFilter.title}
                subtitle={statusFilter.subtitle}
              />
            ))}
          </>
        )}
      </OCRScopingJobsListHeader>
    )
  },
)
